'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoverProvider = function (_React$Component) {
  _inherits(HoverProvider, _React$Component);

  function HoverProvider(props) {
    _classCallCheck(this, HoverProvider);

    var _this = _possibleConstructorReturn(this, (HoverProvider.__proto__ || Object.getPrototypeOf(HoverProvider)).call(this, props));

    _this.state = {
      hovered: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    return _this;
  }

  _createClass(HoverProvider, [{
    key: 'handleMouseEnter',
    value: function handleMouseEnter(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseEnter, evt);
      if (this.state.hovered !== true) this.setState({ hovered: true });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseLeave, evt);
      if (this.state.hovered !== false) this.setState({ hovered: false });
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseMove, evt);
      // See https://git.hubteam.com/HubSpot/UIComponents/issues/3927
      if (this.state.hovered !== true) this.setState({ hovered: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          hoveredProp = _props.hovered;
      var hovered = this.state.hovered;

      return children({
        hovered: hoveredProp != null ? hoveredProp : hovered,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      });
    }
  }]);

  return HoverProvider;
}(_react2.default.Component);

HoverProvider.displayName = 'HoverProvider';

exports.default = HoverProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/providers/HoverProvider.js
// module id = 426
// module chunks = 3 4 5